import axios from "@/api/utils/axios.js";

const baseUrl = '/longstron/base/doc/attachment';

export function getAttachments(entityId) {
  return axios.post(baseUrl + '/listByEntityId/' + entityId);
}

/**
 * @description: 下载文件
 * @param {Object} file 文件
 */
export function download(file) {
  axios.get('/longstron/base/doc/file/download/' + file.id, {
    responseType: 'blob'
  }).then(res => {
    const blob = new Blob([res.data]) // 构造一个blob对象来处理数据
    // IE10以上支持blob但是依然不支持download
    if ('download' in document.createElement('a')) { // 支持a标签download的浏览器
      let anchor = document.createElement('a')
      anchor.download = file.fileName
      anchor.style.display = 'none'
      anchor.href = URL.createObjectURL(blob)
      document.body.appendChild(anchor)
      anchor.click() // 执行下载
      URL.revokeObjectURL(anchor.href) // 释放url
      document.body.removeChild(anchor) // 释放标签
    } else { // 其他浏览器
      navigator.msSaveBlob(blob, file.fileName)
    }
  })
}
